import { render, staticRenderFns } from "./BlockType11.vue?vue&type=template&id=23f67a81"
import script from "./BlockType11.vue?vue&type=script&lang=ts"
export * from "./BlockType11.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports